import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'keepData', pure: false })
export class EscapeDataPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
  }

  transform(content, type: string) {
    if (type === 'image') {
      return this.sanitizer.bypassSecurityTrustUrl(content);
    } else if (type === 'html') {
      // content = content.replaceAll(/href=/gi, 'target="_system" class="externalURLS" href=');
      return this.sanitizer.bypassSecurityTrustHtml(content);
    }
    return this.sanitizer.bypassSecurityTrustHtml(content);
  }
}



// WEBPACK FOOTER //
// ./src/shared/pipes/keepData.pipe.ts